var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "slxc" } },
    [
      _c(
        "el-row",
        [
          _c("el-col", { attrs: { span: 24 } }, [
            _c("div", { staticClass: "header" }, [
              _c("div", { staticClass: "header-left" }, [
                _c("img", {
                  staticStyle: {
                    margin: "0 0.5vw",
                    cursor: "pointer",
                    width: "1vw",
                    height: "1vw"
                  },
                  attrs: { src: "/web/static/img/overview/menu.png" },
                  on: { click: _vm.toggleSideMenu }
                }),
                _vm._v(" " + _vm._s(_vm.todayDate) + " ")
              ]),
              _c("div", { staticClass: "header-right" }, [
                _c(
                  "span",
                  {
                    staticClass: "Backstage",
                    staticStyle: {
                      "line-height": "3.5vh",
                      height: "3.5vh",
                      display: "flex"
                    }
                  },
                  [
                    _c(
                      "span",
                      {
                        staticStyle: {
                          "font-size": "0.8vw",
                          padding: "0.5vh 0.6vw"
                        }
                      },
                      [_vm._v("欢迎您! 管理员")]
                    ),
                    _c(
                      "span",
                      {
                        staticClass: "out",
                        staticStyle: {
                          cursor: "pointer",
                          "margin-right": "1vh",
                          padding: "0.5vh 0"
                        },
                        on: { click: _vm.manage }
                      },
                      [
                        _c("img", {
                          staticStyle: {
                            cursor: "pointer",
                            width: "1vw",
                            height: "1vw"
                          },
                          attrs: {
                            src: "/web/static/img/overview/backstage.png"
                          }
                        })
                      ]
                    ),
                    _c(
                      "span",
                      {
                        staticStyle: {
                          cursor: "pointer",
                          "margin-right": "1vh",
                          padding: "0.5vh 0"
                        },
                        on: { click: _vm.logout }
                      },
                      [
                        _c("img", {
                          staticStyle: {
                            cursor: "pointer",
                            width: "1vw",
                            height: "1vw"
                          },
                          attrs: { src: "/web/static/img/overview/layout.png" }
                        })
                      ]
                    ),
                    _c(
                      "span",
                      {
                        staticStyle: {
                          cursor: "pointer",
                          "margin-right": "1vh",
                          padding: "0.5vh 0"
                        },
                        on: { click: _vm.getFullCreeen }
                      },
                      [
                        _c("img", {
                          staticStyle: {
                            cursor: "pointer",
                            width: "1vw",
                            height: "1vw"
                          },
                          attrs: {
                            src: "/web/static/img/overview/fullscreen.png"
                          }
                        })
                      ]
                    )
                  ]
                )
              ])
            ])
          ])
        ],
        1
      ),
      _c("div", { staticClass: "community-sketch" }),
      _c("SideMenu", {
        attrs: { visible: _vm.showSideMenu },
        on: {
          "update:visible": function($event) {
            _vm.showSideMenu = $event
          }
        }
      }),
      _c(
        "transition",
        { attrs: { name: "fade-in" } },
        [
          _c(_vm.activeView, {
            tag: "component",
            on: { postMapMessage: _vm.handleMapMessage }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }